<template>
  <div class="sidebar-pinned">
    <Navbar />

    <main class="admin-main">
      <section class="admin-content">
        <div class="bg-info m-b-30">
          <div class="container">
            <div class="row p-b-60 p-t-60">
              <div class="col-md-6 text-center mx-auto text-white">
                <div class="m-b-10">
                  <div class="avatar"></div>
                </div>
                <h3 class="h3 text-dark">
                  BASIC HEALTH CARE PROVISION FUND National Health
                            Insurance Scheme Gateway
                </h3>
              </div>
            </div>
          </div>
        </div>
        <section class="container">
          <div class="container">
            <div class="row list">
              <div class="col-lg-12 col-md-12">
                <div class="card m-b-30">
                  <div class="card-body">
                    <form >
                      <div class="row">
                        <div class="col-md-12 my-4 text-center">
                    

                          <p class="h5 mt-2">
                            {{ document.title }}

                          </p>
                        </div>

                        <div class="form-row col-md-12">
                          <div class="form-group col-md-4">
                            <label>Month </label>
                            <input
                              type="month"
                              class="form-control"
                              v-model="document.month"
                              placeholder="January"
                            />
                          </div>
                        </div>

                        <div class="form-group col-md-6">
                          <label for="inputEmail4">Officer Name</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="document.officer_name"
                            placeholder="Your Full Name"
                          />
                        </div>

                        <div class="form-group col-md-6">
                          <label for="inputEmail4">Officer Phone Number</label>
                          <input v-phone
                            type="text"
                            class="form-control"
                            v-model="document.phone_number"
                            placeholder="090-0000-000"
                          />
                        </div>
                      </div>
                    </form>

                    

                  </div>
                </div>
              </div>

             



              <div
                class="card col-md-12"
                v-for="cat in document.categories"
                :key="cat.number"
              >
                <div class="card-header">
                  <p class="h5">{{ cat.number }}. {{ cat.name }}</p>

                </div>

                <div class="card-body table-responsive">
                  <table class="table align-td-middle table-card">
                    <thead>
                      <tr>
                        <th>Number</th>
                        <th>Name</th>
                        <th>Findings</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(doc, index) in cat.questions"
                        v-bind:key="doc.name"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>{{ doc.name }}</td>
                        <td>
                          <div class="form-group col-md-12">
                            <input
                              type="text"
                              class="form-control"
                              v-model="doc.findings"
                              placeholder="Input Response"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>


              
              </div>


              <div class="card col-md-12 my-12">
                  <div class="col-md-12">
                      <button
                        class="btn btn-outline-info btn-block"
                        @click="uploadPicture"
                      >
                        Submit
                        <i class="fe fe-chevron-right"></i>
                      </button>
                    </div>
                </div>
            </div>
          </div>

          <div class="vld-parent">
            <loading
              :active.sync="isLoading"
              loader="dots"
              :can-cancel="true"
              :is-full-page="fullPage"
            ></loading>
          </div>
        </section>
      </section>
    </main>
  </div>
</template>

<script>
import Navbar from "@/views/Navbar.vue";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      user: null,
      options: [
        "NHIA PHC Data Collection Tool",
        "Claims Document",
        "QA Document",
        "Others",
      ],
      doc_name: "",
      quantity: "",
      cost: "",
      singleservice: "",
      singledrug: "",
      claims: "",
      docs: "",
      document: {
        title: "SHIA MONTHLY FACILITY SUMMARY SHEET FOR LGAS",
        type: "NHIA PHC Data Collection Tool",
        lga: "",
        month: "",
        year: "",
        officer_name: "",
        phone_number: "",

        categories: [
          {
            number: "A",
            name: "Enrollment",
            questions: [
              {
                name: "Number of PHCs in this LGA that received the list of BHCPF enrollees for the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Total number of BHCPF enrollees in this LGA",
                findings: "",
                is_others: false,
              },
            ],
          },

          {
            number: "B",

            name: "Financial Management",
            questions: [
              {
                name: "Number of PHCs in this LGA that received payment for capitation in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of PHCs that received payment for capitation within the first 5 days of the reporting month",
                findings: "",
                is_others: false,
              },

              {
                name: "Amount in total received by PHCs in this LGA for capitation in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of SHCs in this LGA that submitted claims to SSHIAs for the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of SHCs in this LGA that submitted claims to SSHIAs within 30 days from the end of the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Total amount requested in the claims submitted for the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of SHCs in this LGA whose vetted claims were reimbursed for the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of SHCs in this LGA whose vetted claims were reimbursed not later than 30 days from claims submission for the reporting month",
                findings: "",
                is_others: false,
              },

              {
                name: "Total amount reimbursed",
                findings: "",
                is_others: false,
              },
            ],
          },

          {
            number: "C",
            name: "Service Utilization in PHCs",
            questions: [
              {
                name: "Total number of BHCPF enrollees that accessed service in PHCs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Total number of services utilized by enrollees in this LGA for the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of  BHCPF enrollees in total that were referred from PHCs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees in total that attended ANC in PHCs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees in total that accessed immunization services in PHCs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees in total that were treated for malaria in PHCs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees in total that were screened for hypertension in PHCs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees in total that were screened for diabetes mellitus in PHCs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees in total that were treated for typhoid fever in PHCs in this LGA in the reporting month?",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees in total that were treated for respiratory tract infection in PHCs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees in total that were treated for diarrhoea in PHCs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees in total that were treated for urinary tract infection in PHCs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees in total that were treated for gastroenteritis in PHCs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees in total that had normal delivery in PHCs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Total number of deaths in total (in relation to BHCPF beneficiaries) that were recorded in PHCs in this LGA in the reporting month",
                findings: "",
                is_others: true,
              },
              {
                name: "Maternal deaths (BHCPF enrollees)",
                findings: "",
                is_others: true,
              },
              {
                name: "Neonatal (0-30 days) deaths (BHCPF enrollees)",
                findings: "",
                is_others: true,
              },
              {
                name: "Infant (1-12 months) deaths (BHCPF enrollees)",
                findings: "",
                is_others: true,
              },
              {
                name: "Children (1-5 years) deaths (BHCPF enrollees)",
                findings: "",
                is_others: true,
              },
            ],
          },

          {
            number: "D",
            name: "Service Utilization in SHCPs",
            questions: [
              {
                name: "Number of BHCPF enrollees in total that were referred for caesarean section to the SHCPs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees in total that were treated for hypertension in SHCPs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees in total that were treated for diabetes mellitus in SHCPs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees that were treated for severe malaria in SHCPs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees that were treated for complicated respiratory tract infection in SHCPs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees that were treated for severe urinary tract infection in SHCPs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Number of BHCPF enrollees that were treated for complicated typhoid fever in SHCPs in this LGA in the reporting month",
                findings: "",
                is_others: false,
              },
              {
                name: "Total number of deaths in total (in relation to referred BHCPF beneficiaries) that were recorded in the SHCPs in this LGA in the reporting month",
                findings: "",
                is_others: true,
              },

              {
                name: "Maternal deaths (BHCPF enrollees)",
                findings: "",
                is_others: true,
              },
              {
                name: "Neonatal (0-30 days) deaths (BHCPF enrollees)",
                findings: "",
                is_others: true,
              },

              {
                name: "Infant (1-12 months) deaths (BHCPF enrollees)",
                findings: "",
                is_others: true,
              },
              {
                name: "Children (1-5 years) deaths (BHCPF enrollees)",
                findings: "",
                is_others: true,
              },
            ],
          },

          {
            number:"E",
            name: "Quality Assurance",
            questions: [
              {
                name: "What is the total number of BHCPF PHCs where quality assessment was conducted in the reporting month?",
                findings: "",
              },
              {
                name: "What is the total number of BHCPF SHCFs where quality assessment was conducted in the reporting month?",
                findings: "",
              },
              {
                name: "Total number of facilities that made up to an average quality assessment score of 60% in the reporting month?",
                findings: "",
              },
            ],
          },

          {
            number:"F",
            name: "Governance",
            questions: [
              {
                name: "Number of PHCs that their staff have been trained on operations of the NHIS gateway",
                findings: "",
              },
              {
                name: "Number of SHCFs that their staff have been trained on operations of the NHIS gateway",
                findings: "",
              },
            ],
          },
        ],
      },
      edit: false,
      isLoading: false,
      fullPage: true,
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },

  methods: {
    getDocuments() {
      this.user = JSON.parse(localStorage.getItem("user"));

      this.axios
        .get(`/api/v1/auth/all-documentsprovider/${this.user.institutional_id}`)
        .then((response) => {
          this.docs = response.data;
          console.log(response);
        });
    },

    clearIt() {
      this.document.name = "";
    },

    attachPic(event) {
      this.user = JSON.parse(localStorage.getItem("user"));
      console.log(event);
      this.image = event.target.files[0];
      // this.uploadPicture();
    },
    uploadPicture() {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      let formData = new FormData();
      formData.append("agency_id", 90);
      formData.append("claim_document", this.image);
      formData.append("type", this.document.title);
      formData.append("provider_id", this.user.institutional_id);
      formData.append("doc_name",  JSON.stringify(this.document));
      this.axios
        .post("/api/v1/auth/uploadDocument", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$toasted.info("uploaded Successfully", {
            position: "top-center",
            duration: 3000,
          });
          this.clearIt();
          this.getDocuments();
        })
        .catch((error) => {
          // this.$toasted.error("Error Uploading", {
          //   position: "top-center",
          //   duration: 3000,
          // });

          this.$toasted.info("Submitted Successfully", {
            position: "top-center",
            duration: 3000,
          });
          console.error(error);
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getDocuments();
  },
};
</script>
